import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaRegUserCircle } from "react-icons/fa";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { MdError, MdCheck } from "react-icons/md";
import { RiShieldUserLine } from "react-icons/ri";
import { useUser } from "../../context/user-context";
import { useNavigate } from "react-router-dom";

const KYC = ({
  setOpenKyc,
  setOpenKyc3,
  setOpenBankDetails,
  setOpenAddPhone,
}: any) => {
  const [openLevel1, setOpenLevel1] = useState<boolean>(false);
  const [openLevel2, setOpenLevel2] = useState<boolean>(false);
  const [openLevel3, setOpenLevel3] = useState<boolean>(false);
  const [isNotVerified, setIsNotVerified] = useState<boolean>(true);
  const navigate = useNavigate();
  const { userDetails } = useUser();
  const bankDetails = userDetails?.user.banks;
  const phoneNumber = userDetails?.user.phone.number;
  const kycStatus = userDetails?.user?.kyc?.status;

  useEffect(() => {
    if (
      !userDetails?.user?.kyc ||
      kycStatus === "NONE" ||
      kycStatus === "DENIED"
    ) {
      setIsNotVerified(true);
    } else if (kycStatus === "VERIFIED") {
      setIsNotVerified(false);
    }
  }, [kycStatus, userDetails?.user?.kyc]);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenKyc(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-medium text-[20px]">
            KYC Verification
          </h4>
        </div>
        <div className="mt-8 w-full">
          <div className="w-full">
            <div
              className={
                "w-full mt-10 flex justify-center lgss:justify-start items-start"
              }
            >
              <div className={"w-full "}>
                <div
                  onClick={() => {
                    if (bankDetails.length >= 1 && phoneNumber) {
                    } else {
                      setOpenLevel1((prev) => !prev);
                    }
                  }}
                  className={
                    openLevel1
                      ? "border cursor-pointer border-secondary_button  rounded-lg p-4 "
                      : "border border-gray-200 hover:border-3 hover:shadow-lg transition-shadow duration-500 ease-out  dark:border-gray-600 rounded-lg p-4  "
                  }
                >
                  <div className=" flex justify-between items-center">
                    <div className="flex justify-start items-center gap-4">
                      <FaRegUserCircle className="text-[30px] text-[#0B75C2]" />
                      <div>
                        <div className="flex justify-start items-center gap-3">
                          <h4 className="text-[16px] text-paragraph dark:text-gray-300 font-medium">
                            Level 1
                          </h4>
                          {bankDetails.length >= 1 && phoneNumber ? (
                            <div className="p-1.5 bg-[#D4EBFD] rounded-sm text-[9px]  font-semibold text-secondary_button">
                              COMPLETED
                            </div>
                          ) : (
                            <div className="p-1.5 bg-[#FDEDDB] rounded-sm text-[9px]  font-semibold text-[#F28A0F]">
                              REQUIRED
                            </div>
                          )}
                        </div>
                        <h4 className="text-[#617889] mt-2 dark:text-white text-[13px]  xs:text-[14px] ">
                          Profile setup
                        </h4>
                      </div>
                    </div>
                    {!bankDetails || bankDetails.length < 1 || !phoneNumber ? (
                      <MdError className="text-[24px] text-[#617889] dark:text-gray-300" />
                    ) : (
                      <MdCheck className="text-[24px] text-secondary_button" />
                    )}
                  </div>
                  {openLevel1 && (
                    <div className="w-full transition ease-in duration-700">
                      <div className=" w-full mt-6 p-4 rounded-lg bg-[#C6D0D7]">
                        <h4 className="text-[13px] text-paragraph font-medium">
                          1.Your profile needs to be set up such as your DeeX
                          Tag, Bank details and Phone Number.
                        </h4>
                      </div>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (bankDetails.length === 0) {
                            setOpenKyc(false);
                            setOpenBankDetails(true);
                          } else if (bankDetails.length >= 1 && !phoneNumber) {
                            setOpenKyc(false);
                            setOpenAddPhone(true);
                          }
                        }}
                        className="w-full h-[48px] flex justify-center items-center  text-white bg-secondary_button rounded-xl mt-8 text-[14px] font-medium xs:text-[16px]"
                      >
                        Complete your profile
                      </button>
                    </div>
                  )}
                </div>
                <div
                  onClick={() => {
                    if (bankDetails.length >= 1 && isNotVerified === true) {
                      setOpenLevel2((prev) => !prev);
                    }
                  }}
                  className={
                    openLevel2
                      ? "border cursor-pointer border-secondary_button  rounded-lg p-4 mt-10"
                      : "border border-gray-200 hover:border-3 transition-shadow duration-500 ease-out hover:shadow-lg dark:border-gray-600 rounded-lg p-4 mt-10 "
                  }
                >
                  <div className=" flex justify-between items-center">
                    <div className="flex justify-start items-center gap-4">
                      <RiShieldUserLine className="text-[30px] text-[#0B75C2]" />
                      <div>
                        <div className="flex justify-start items-center gap-3">
                          <h4 className="text-[16px] text-paragraph dark:text-gray-300 font-medium">
                            Level 2
                          </h4>
                          {isNotVerified === false ? (
                            <div className="p-1.5 bg-[#D4EBFD] rounded-sm text-[9px]  font-semibold text-secondary_button">
                              COMPLETED
                            </div>
                          ) : (
                            <div className="p-1.5 bg-[#FDEDDB] rounded-sm text-[9px]  font-semibold text-[#F28A0F]">
                              REQUIRED
                            </div>
                          )}
                        </div>
                        <h4 className="text-[#617889] mt-2 dark:text-white text-[13px]  xs:text-[14px] ">
                          BVN Verification
                        </h4>
                      </div>
                    </div>
                    {isNotVerified === false ? (
                      <MdCheck className="text-[24px] text-secondary_button" />
                    ) : (
                      <MdError className="text-[24px] text-[#617889] dark:text-gray-300" />
                    )}
                  </div>
                  {openLevel2 && (
                    <div className="w-full">
                      <div className=" w-full mt-6 p-4 rounded-lg bg-[#C6D0D7]">
                        <h4 className="text-[13px] text-paragraph font-medium">
                          1.Your BVN is required to upgrade to level.
                          <br />
                          2. After your verification is successful, you will be
                          able to perform your first transaction.
                        </h4>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/kyc-onboarding");
                        }}
                        className="w-full h-[48px] text-white bg-secondary_button rounded-xl mt-8 text-[14px] font-medium xs:text-[16px]"
                      >
                        Upgrade to Level 2
                      </button>
                    </div>
                  )}
                </div>
                <div
                  onClick={() => {
                    if (
                      userDetails?.user?.kyc3 === "Approved" ||
                      userDetails?.user?.kyc3 === "Pending"
                    ) {
                      setOpenLevel3(false);
                    } else if (
                      bankDetails.length >= 1 &&
                      isNotVerified === false
                    ) {
                      setOpenLevel3(true);
                    }
                  }}
                  className={
                    openLevel3
                      ? "border cursor-pointer border-secondary_button  rounded-lg p-4 mt-10"
                      : "border border-gray-200 hover:border-3 transition-shadow duration-500 ease-out hover:shadow-lg dark:border-gray-600 rounded-lg p-4 mt-10 cursor-pointer"
                  }
                >
                  <div className=" flex justify-between items-center">
                    <div className="flex justify-start items-center gap-4">
                      <IoShieldCheckmarkOutline className="text-[30px] text-[#0B75C2]" />
                      <div>
                        <div className="flex justify-start items-center gap-3">
                          <h4 className="text-[16px] text-paragraph dark:text-gray-300 font-medium">
                            Level 3
                          </h4>
                          {userDetails?.user?.kyc3 === "Approved" ? (
                            <div className="p-1.5 bg-[#D4EBFD] rounded-sm text-[9px]  font-semibold text-secondary_button">
                              COMPLETED
                            </div>
                          ) : (
                            <div className="p-1.5 bg-[#FDEDDB] rounded-sm text-[9px]  font-semibold text-[#F28A0F]">
                              {userDetails?.user?.kyc3 === "Pending"
                                ? "PENDING"
                                : "REQUIRED"}
                            </div>
                          )}
                        </div>
                        <h4 className="text-[#617889] mt-2 dark:text-white text-[13px]  xs:text-[14px] ">
                          ID Verification. Available on mobile
                        </h4>
                      </div>
                    </div>
                    {userDetails?.user?.kyc3 === "Approved" ? (
                      <MdCheck className="text-[24px] text-secondary_button" />
                    ) : (
                      <MdError className="text-[24px] text-[#617889] dark:text-gray-300" />
                    )}
                  </div>
                  {openLevel3 && (
                    <div className="transition duration-500 ease-in w-full">
                      <div className=" w-full mt-6 p-4 rounded-lg bg-[#C6D0D7]">
                        <ul className="list-disc px-4">
                          <li className="text-[13px] text-paragraph font-medium">
                            We need your Govt ID to upgrade your account to
                            level 3
                          </li>
                          <li className="text-[13px] text-paragraph font-medium">
                            You need to provide a proof of address.
                          </li>
                          <li className="text-[13px] text-paragraph font-medium">
                            This level allows you to enjoy the full features of
                            DeeXoptions, such as wallet and transfer.
                          </li>
                        </ul>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenKyc(false);
                          setOpenKyc3(true);
                        }}
                        className="w-full h-[48px] text-white bg-secondary_button rounded-xl mt-8 text-[14px] font-medium xs:text-[16px]"
                      >
                        Upgrade to Level 3
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {/* <div className={level ? "flex flex-col w-full lgss:w-1/2" : "hidden"}>
            <Bvn setRefetchCount={setRefetchCount} />
          </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KYC;
